(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["starless-review-simulation"] && !Shopify.designMode) return;
  try {
    (() => {
    const initialize = (root) => {
      if (root.dataset.ready) return;
      const section = root.closest('.starless-customer-reviews');
      const rail = root.querySelector('[data-sim-rail]');
      const previous = root.querySelector('[data-sim-previous]');
      const next = root.querySelector('[data-sim-next]');
      const position = root.querySelector('[data-sim-position]');
      const navigation = root.querySelector('[data-sim-navigation]');
      const summary = section.querySelector('[data-sim-summary]');
      if (!rail || !summary) return;
      root.dataset.ready = 'true';
      const locale = document.documentElement.lang || 'en';
      const numberFormat = new Intl.NumberFormat(locale, { minimumFractionDigits: 1, maximumFractionDigits: 1 });
      let cards = [];
      let activeCard = null;
      let activeIndex = 0;
      let manualScroll = false;
      let scrollFrame = 0;
      let pointerOrigin = null;
      const rating = (card) => {
        const value = Number(card.dataset.simRating);
        return Number.isFinite(value) && value >= 1 && value <= 5 ? value : null;
      };
      const positionLabel = (index) => position.dataset.positionLabel
        .replace('[current]', String(index + 1)).replace('[total]', String(cards.length));
      const updateNavigation = () => {
        cards.forEach((card, index) => {
          card.setAttribute('aria-current', index === activeIndex ? 'true' : 'false');
          card.tabIndex = index === activeIndex ? 0 : -1;
          card.setAttribute('aria-label', positionLabel(index));
        });
        navigation.hidden = !cards.length;
        previous.disabled = activeIndex <= 0;
        next.disabled = !cards.length || activeIndex >= cards.length - 1;
        position.textContent = `${cards.length ? activeIndex + 1 : 0} / ${cards.length}`;
        position.setAttribute('aria-label', cards.length ? positionLabel(activeIndex) : summary.dataset.emptyLabel);
        root.dataset.activeReview = cards.length ? String(activeIndex + 1) : '0';
      };
      const updateSummary = () => {
        const ratings = cards.map(rating).filter((value) => value !== null);
        const sum = ratings.reduce((total, value) => total + value, 0);
        const average = ratings.length ? sum / ratings.length : 0;
        const text = ratings.length ? numberFormat.format(average) : '—';
        summary.querySelector('[data-sim-average]').textContent = text;
        summary.querySelector('[data-sim-average-stars]').style.setProperty('--starless-rating-fill', `${average * 20}%`);
        summary.querySelector('[data-sim-summary-count]').textContent =
          (ratings.length === 1 ? summary.dataset.countOne : summary.dataset.countOther).replace('[count]', String(ratings.length));
        summary.setAttribute('aria-label', ratings.length
          ? summary.dataset.summaryLabel.replace('[rating]', text).replace('[count]', String(ratings.length))
          : summary.dataset.emptyLabel);
        summary.dataset.ratingCount = String(ratings.length);
        summary.dataset.ratingAverage = String(average);
        cards.forEach((card) => {
          const stars = card.querySelector('[data-sim-card-stars]');
          if (!stars) return;
          const value = rating(card);
          stars.style.setProperty('--starless-rating-fill', `${(value || 0) * 20}%`);
          stars.setAttribute('aria-label', root.dataset.ratingLabel.replace('[count]', value === null ? '—' : String(value)));
        });
      };
      const revealActive = (smooth = true) => {
        if (!activeCard) return;
        const bounds = rail.getBoundingClientRect();
        const cardBounds = activeCard.getBoundingClientRect();
        let left = rail.scrollLeft;
        if (cardBounds.left < bounds.left - 1) left += cardBounds.left - bounds.left;
        else if (cardBounds.right > bounds.right + 1) left += cardBounds.right - bounds.right;
        rail.scrollTo({ left, behavior: smooth && !matchMedia('(prefers-reduced-motion: reduce)').matches ? 'smooth' : 'auto' });
      };
      const activate = (index, reveal = true) => {
        if (!cards.length) return;
        activeIndex = Math.max(0, Math.min(cards.length - 1, index));
        activeCard = cards[activeIndex];
        manualScroll = false;
        updateNavigation();
        if (reveal) revealActive();
      };
      const refresh = () => {
        cards = Array.from(rail.querySelectorAll('[data-sim-card]'));
        activeIndex = activeCard && cards.includes(activeCard)
          ? cards.indexOf(activeCard) : Math.max(0, Math.min(activeIndex, cards.length - 1));
        activeCard = cards[activeIndex] || null;
        manualScroll = false;
        updateSummary();
        updateNavigation();
        revealActive(false);
      };
      previous.addEventListener('click', () => activate(activeIndex - 1));
      next.addEventListener('click', () => activate(activeIndex + 1));
      rail.addEventListener('click', (event) => {
        const card = event.target.closest('[data-sim-card]');
        if (cards.includes(card)) activate(cards.indexOf(card));
      });
      rail.addEventListener('focusin', (event) => {
        const card = event.target.closest('[data-sim-card]');
        if (cards.includes(card)) activate(cards.indexOf(card));
      });
      rail.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        if (event.key === 'Home') activate(0);
        else if (event.key === 'End') activate(cards.length - 1);
        else activate(activeIndex + (event.key === 'ArrowRight' ? 1 : -1));
        if (event.target.closest('[data-sim-card]') && activeCard) activeCard.focus({ preventScroll: true });
      });
      rail.addEventListener('pointerdown', (event) => {
        pointerOrigin = { x: event.clientX, y: event.clientY };
      }, { passive: true });
      rail.addEventListener('pointermove', (event) => {
        if (!pointerOrigin) return;
        const horizontal = Math.abs(event.clientX - pointerOrigin.x);
        const vertical = Math.abs(event.clientY - pointerOrigin.y);
        if (horizontal > 4 && horizontal > vertical) manualScroll = true;
      }, { passive: true });
      const endPointer = () => { pointerOrigin = null; };
      rail.addEventListener('pointerup', endPointer, { passive: true });
      rail.addEventListener('pointercancel', endPointer, { passive: true });
      rail.addEventListener('wheel', (event) => {
        if (Math.abs(event.deltaX) > Math.abs(event.deltaY) || (event.shiftKey && event.deltaY)) manualScroll = true;
      }, { passive: true });
      rail.addEventListener('scroll', () => {
        if (!manualScroll || scrollFrame || !cards.length) return;
        scrollFrame = requestAnimationFrame(() => {
          scrollFrame = 0;
          if (!manualScroll) return;
          const bounds = rail.getBoundingClientRect();
          const center = bounds.left + bounds.width / 2;
          let closest = 0;
          let distance = Infinity;
          cards.forEach((card, index) => {
            const rect = card.getBoundingClientRect();
            const difference = Math.abs(rect.left + rect.width / 2 - center);
            if (difference < distance) { distance = difference; closest = index; }
          });
          activeIndex = closest;
          activeCard = cards[activeIndex];
          updateNavigation();
        });
      }, { passive: true });
      const mutationObserver = new MutationObserver((records) => {
        if (records.some((record) => record.type === 'attributes' || record.target === rail)) refresh();
      });
      mutationObserver.observe(rail, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-sim-rating'] });
      const resizeObserver = new ResizeObserver(() => { manualScroll = false; updateNavigation(); revealActive(false); });
      resizeObserver.observe(rail);
      document.addEventListener('shopify:section:unload', (event) => {
        if (event.target.contains(root)) { mutationObserver.disconnect(); resizeObserver.disconnect(); cancelAnimationFrame(scrollFrame); }
      });
      refresh();
    };
    const initializeAll = () => document.querySelectorAll('[data-review-simulation]').forEach(initialize);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
    else initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
  })();
  } catch(e) { console.error(e); }
})();

})();
